import React, { Component } from 'react';
import AudioPlayer from '../../../global/AudioPlayer';
import styles from './audioClip.module.scss';

const AudioClip = ({ title, audio_file, body }) => (
  <div className={styles.container}>
    {title && (
      <h4
        className={styles.title}
        dangerouslySetInnerHTML={{ __html: title }}
      />
    )}
    {body && (
      <div className={styles.body} dangerouslySetInnerHTML={{ __html: body }} />
    )}
    {audio_file &&
      audio_file.url && <AudioPlayer source={audio_file.url} title={null} />}
  </div>
);

export default AudioClip;



// WEBPACK FOOTER //
// ./src/components/tour/details/teasers/AudioClip.js